import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Step, Stepper, StepConnector, StepLabel } from "@material-ui/core";
import { Add, Print, Receipt } from "@material-ui/icons";
import AssignmentIcon from "@material-ui/icons/Assignment";
import PropTypes from "prop-types";
import clsx from "clsx";

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 40,
    height: 40,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  let icons;
  icons = {
    1: <Receipt />,
    2: <Add />,
    3: <AssignmentIcon />,
    4: <Print />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: 10,
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttonRoot: {
    margin: 25,
  },
  rootListadoc: {
    margin: 25,
  },
}));

export const ReclamosStepper = (props) => {
  const classes = useStyles();

  let steps;
  steps = [
    "Ingreso",
    "Guardar ",
    "Documentación",
    "Imprimir ",
  ];

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={props.activeStep}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};
